import { ASSETS_ENDPOINT, THUMBNAIL_ASSETS_ENDPOINT } from './enviroment'

export function getAssetUrl (url?: string | null) {
  return `${ASSETS_ENDPOINT}${url ?? ''}`
}

export function getCompressedImageUrl (url?: string | null) {
  return `${THUMBNAIL_ASSETS_ENDPOINT}${url ?? ''}`
}
